import { AuthorizedStates } from "common/picker/types";
import { reduce } from "lodash";
import { find } from "lodash";

type T = string | number;

export const checkFilter = (
  filter: { [x: string]: T[] },
  filterKeyMapper: { [key: string]: string },
  filterValueMapper: { [key: string]: T[] }
) => {
  const ErrorMsg = reduce(
    filter,
    (wrongElements: { keys: string[]; values: T[] }, values, key) => {
      const wrongKeys = wrongElements.keys.concat(
        !filterKeyMapper[key] ? key : []
      );
      const wrongValues = filterKeyMapper[key]
        ? wrongElements.values.concat(
            values.filter(
              (value: T) =>
                !find(
                  filterValueMapper[key],
                  filterValue => filterValue === value
                )
            )
          )
        : wrongElements.values;
      return { keys: wrongKeys, values: wrongValues };
    },
    { keys: [], values: [] }
  );

  if (ErrorMsg.keys.length || ErrorMsg.values.length) {
    const keysMsg = ErrorMsg.keys.length
      ? "[Keys] " + ErrorMsg.keys.join(" ") + " "
      : "";
    const valuesMsg = ErrorMsg.values.length
      ? "[Values] " + ErrorMsg.values.join(" ") + " "
      : "";
    throw new Error("[FILTER] Incorrect Arguments: " + keysMsg + valuesMsg);
  }
};

export const checkState = (state: string) => {
  if (state && !find(AuthorizedStates, authState => authState === state)) {
    throw new Error("Incorrect state : " + state);
  }
};

export const onClick = (
  base: HTMLElement | undefined,
  hostName: string,
  e: MouseEvent,
  checkForShadowRootChildren = false
): boolean => {
  const target = e.target as Element | null;
  if (base && base.contains(target)) {
    return false;
  }
  if (target && target.nodeName === hostName) {
    return false;
  }
  if (
    checkForShadowRootChildren &&
    target &&
    target.shadowRoot &&
    target.shadowRoot.childNodes &&
    target.shadowRoot.childElementCount > 0
  ) {
    for (let index = 0; index < target.shadowRoot.childElementCount; index++) {
      if (target.shadowRoot.childNodes[index].nodeName === hostName) {
        return false;
      }
    }
  }
  return true;
};
